import React from 'react';
import { styles } from './styles';
import { withStyles, StyledComponentProps, Typography } from '@material-ui/core';
import { MenuPostPublished } from '../../ui-components/Icons';

const comp = (props: StyledComponentProps) => {
    return (<div className={props.classes.root}>
        <MenuPostPublished  className={props.classes.subHeaderIcon}/>
        <Typography className={props.classes.title} variant='h6'>Post inviati</Typography>
    </div>)
}

export const SentPosts = withStyles(styles)(comp)